<template>
  <div>
    <div class="keypointBtn">
      <Dropdown placement="bottom-start">
        <Button size="small" type="primary">提货点</Button>
        <ul slot="list" class="actionul">
          <li @click="addTihuo(x)" v-for="(x, index) in tihuos" :key="index">
            {{ x.address.split("_")[0] }}
          </li>
        </ul>
      </Dropdown>
      <Dropdown placement="bottom-start">
        <Button size="small" type="success">卸货点</Button>
        <ul slot="list" class="actionul">
          <li @click="addXiehuo(x)" v-for="(x, index) in xiehuos" :key="index">
            {{ x.address.split("_")[0] }}
          </li>
        </ul>
      </Dropdown>
      <Dropdown placement="top-start">
        <Button size="small" type="warning">途经点</Button>
        <ul slot="list" class="actionul">
          <li @click="addTujing(x)" v-for="(x, index) in tujing" :key="index">
            {{ x.address.split("_")[0] }}
          </li>
        </ul>
      </Dropdown>
      <Button @click="markerList.splice(0, 100)" size="small">清空站点</Button>
    </div>

    <div class="keyPointWrap">
      <div class="keyPointWrapline"></div>

      <div class="stations">
        <station v-for="(x, index1) in markerList" :key="index1" :station="x" @del="markerList.splice(index1, 1)"
          @prev="prev(index1)" @next="next(index1)"></station>
      </div>
    </div>
  </div>
</template>
<script>
import station from "./station.vue";
export default {
  components: { station },
  data() {
    return {
      markerList: [
        /* {
          cs: 2,
          address: "广东省深圳市宝安区石岩街道锦宏工业园",
          name: "盐田某小区",
          x: 113.926394,
          y: 22.689463,
          id: 1692951651204,
          radius: 500,
          action: "提货",
        },
        {
          cs: 2,
          address: "广东省深圳市宝安区石岩街道锦宏工业园",
          name: "龙岗某工业园",
          x: 113.926394,
          y: 22.689463,
          id: 1692951651204,
          radius: 500,
          action: "提货",
        },
        {
          cs: 2,
          address: "广东省深圳市罗湖区东湖街道罗湖梧桐绿道",
          name: "莲塘口岸",
          x: 114.179543,
          y: 22.596734,
          id: 1692951653204,
          radius: 200,
          action: "途经",
        },
        {
          cs: 2,
          address: "香港特别行政区湾仔区轩尼诗道187号华美楼(轩尼诗道)",
          name: "香港元朗区某小区1",
          x: 114.171203,
          y: 22.277468,
          id: 1697503879573,
          radius: 50,
          action: "卸货",
        },
        {
          cs: 2,
          address: "香港特别行政区湾仔区轩尼诗道187号华美楼(轩尼诗道)",
          name: "香港元朗区某小区2",
          x: 114.171203,
          y: 22.277468,
          id: 1697503879573,
          radius: 50,
          action: "卸货",
        }, */
      ],
      tihuos: [
        {
          cs: 2,
          address: "鑫和冠仓库_广东省深圳市宝安区石岩街道锦宏工业园",
          name: "鑫和冠仓库",
          x: 113.926394,
          y: 22.689463,
          id: 1692951651204,
          radius: 500,
          action: "提货",
        },
        {
          cs: 2,
          address: "香港xx仓库_广东省深圳市宝安区石岩街道锦宏工业园",
          name: "香港xx仓库",
          x: 113.926394,
          y: 22.689463,
          id: 1692951651204,
          radius: 500,
          action: "提货",
        },
      ],
      xiehuos: [
        {
          cs: 2,
          address: "鑫和冠仓库_广东省深圳市宝安区石岩街道锦宏工业园",
          name: "鑫和冠仓库",
          x: 113.926394,
          y: 22.689463,
          id: 1692951651204,
          radius: 500,
          action: "提货",
        },
        {
          cs: 2,
          address: "香港xx仓库_广东省深圳市宝安区石岩街道锦宏工业园",
          name: "香港xx仓库",
          x: 113.926394,
          y: 22.689463,
          id: 1692951651204,
          radius: 500,
          action: "提货",
        },
      ],
      tujing: [
        /* {
          cs: 2,
          address: "广东省深圳市罗湖区东湖街道罗湖梧桐绿道",
          name: "莲塘口岸",
          x: 114.179543,
          y: 22.596734,
          id: 1692951653204,
          radius: 200,
          action: "途经",
        }, */
      ],
    };
  },
  methods: {
    reach(tihuos, xiehuos, tujing) {
      this.markerList = [...tihuos, ...tujing, ...xiehuos];
      this.getPoints(tihuos, xiehuos, tujing)
    },
    addTihuo(v) {
      var markerList = this.markerList;

      var status = false;
      for (let i = 0; i < markerList.length; i++) {

        if (v.address == markerList[i].address) {
          status = true;
          break
        }
      }
      if (status) {
        this.$Message.error('该点已存在');
      } else {
        markerList.unshift(v)
      }

    },
    addTujing(v) {
      var t = 0;
      var m = this.markerList;
      var status = false;
      for (let i = 0; i < m.length; i++) {
        if (v.address == m[i].address) {
          status = true;
          break
        }
        if (m[i].action == "提货") {
          t += 1;
        }
      }
      if (status) {
        this.$Message.error('该点已存在');
      } else {
        this.markerList.splice(t, 0, v);
      }

    },
    addXiehuo(v) {
      var markerList = this.markerList;
      var status = false;
      for (let i = 0; i < markerList.length; i++) {

        if (v.address == markerList[i].address) {
          status = true;
          break
        }
      }
      if (status) {
        this.$Message.error('该点已存在');
      } else {
        markerList.push(v)
      }

    },
    prev(index) {
      if (index == 0) {
        return;
      }
      var m = this.markerList[index];
      this.markerList.splice(index, 1);
      //setTimeout(() => {
      this.markerList.splice(index - 1, 0, m);
      //}, 5000);
    },
    next(index) {
      if (index == this.markerList.length) {
        return;
      }
      var m = this.markerList[index];
      this.markerList.splice(index, 1);
      //setTimeout(() => {
      this.markerList.splice(index + 1, 0, m);
    },
    getVal() {
      return this.markerList;
    },
    getPoints(tihuos, xiehuos, tujing) {
      this.axios({
        method: "post",
        url: this.axios.rule + "/marker/list",
        data: {},
      }).then((res) => {
        var data = res.data.data.dataList;
        this.tihuos.length = 0;
        this.xiehuos.length = 0;
        for (let i = 0; i < data.length; i++) {
          if (data[i].type.indexOf('仓库') != -1) {
            data[i].address=data[i].name+'_'+data[i].address;
            data[i].action='提货';
            this.tihuos.push(data[i]);
          }
        }
        var t=JSON.parse(JSON.stringify(this.tihuos));
        for (let i = 0; i < t.length; i++) {
          t[i].action='卸货' 
        }
        this.xiehuos=t;
        this.tihuos = this.tihuos.concat(tihuos);
        this.xiehuos = this.xiehuos.concat(xiehuos);
        this.tujing = tujing;

        //this.markerList = this.markerList.concat(this.tihuos);

      });
    }
  },
};
</script>
<style>
.keyPointWrap {
  position: relative;
}

.keyPointWrap .stations {
  margin: 0 auto;
  position: relative;
  display: flex;
  height: 120px;
  border-bottom: solid 1px #ffffff;
}

.keypointBtn {
  margin-bottom: 10px;
}

.keypointBtn button {
  margin-right: 10px;
}

.keypointBtn .tishi {
  color: red;
  padding: 6px;
}

.keyPointWrapline {
  position: absolute;
  width: 100%;
  height: 6px;
  background: #77c0ed;
  top: 7px;
  z-index: 0;
}

.actionul li {
  padding: 2px 10px;
}

.actionul li:hover {
  background: #bfe2f8;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/stations.vue